import api from './api';

const service = {
  async search(params) {
    return await api.get(`/price-forecast`, { params });
  },
}

export default service;